import AWS from "aws-sdk";
import {
  CognitoUserPool,
// ***  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails
} from "amazon-cognito-identity-js";
import React from 'react';
// *** import { userIdFunc, handleErrorFunc } from '../App';
import { handleErrorFunc } from '../App';

import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import appConfig from '../appConfig';

/*******************************
AWS.config.region = appConfig.region;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: appConfig.IdentityPoolId
});
*******************************/

const userPool = new CognitoUserPool({
  UserPoolId: appConfig.UserPoolId,
  ClientId: appConfig.ClientId,
});



export default class LoginView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: ""
    };
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleSubmit(e) {
    e.preventDefault();
    const email = this.state.email.trim();
    const password = this.state.password.trim();

    const authenticationData = {
        Username : email,
        Password : password,
    };

    var authenticationDetails = new AuthenticationDetails(authenticationData);
    const _self = this;

    var userData = {
        Username : email,
        Pool : userPool
    };

    var cognitoUser = new CognitoUser(userData);

//================================================①Authentication(認証)
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
            //console.log('access token + ' + result.getAccessToken().getJwtToken());

//================================================②Authorization(承認)--ARNへのアクセス権限
            AWS.config.region = appConfig.region;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: appConfig.IdentityPoolId,
                Logins : {
                    // Change the key below according to the specific region your user pool is in.
                    'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_xn9ihTu0b' : result.getIdToken().getJwtToken()
                }
            });
//================================================
// ***           AWS.config.credentials.refresh(function(){
            AWS.config.credentials.get(function(){
//================================================
              //console.log("##############"+AWS.config.credentials)
              var identityId = AWS.config.credentials.identityId;
              console.log("AWS.config.credentials.get ok : identityId="+identityId)
              _self.setState({identityId: identityId});

              var username = "";
              cognitoUser.getUserAttributes((err, result) => {
                for (var i = 0; i < result.length; i++) {
                    console.log('attribute ' + result[i].getName() + ' has value ' + result[i].getValue());
                    if( result[i].getName() === "name") {
                        username = result[i].getValue();
                        //console.log("### username"+username);
                        localStorage.setItem('username', username);
                        break;
                    }
                }
              });

             localStorage.setItem('email', email);

             _self.props.history.push({pathname: '/'});
//================================================
            })
//================================================
        },
        onFailure: function(err) {
            handleErrorFunc('エラー：ログイン失敗: '+err);
            //alert(err);
        },
    });

  }

  render () {
    const style = {
      width: '80%',
      margin: 50,
      padding: 50,
      display: 'inline-block',
    };
    return (
      <div>
        <Paper style={style} zDepth={1}>
          <h2 style={{textAlign: 'left'}}>ログイン</h2>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <TextField fullWidth={true}
                 value={this.state.email}
                 hintText="Email"
                 onChange={this.handleEmailChange.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.password}
                 hintText="パスワード"
                 onChange={this.handlePasswordChange.bind(this)}/><br />
            <input type="submit"/>
          </form>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/LoginView.js